import React from "react";
import { Platform, Text } from "react-native";
import glyphMap from "./FontAwesome5.json";
import { Container } from "../layout/common";

const Icon = ({ margins, backgroundColor, ...props }) => {
  let weight = props.weight || 400,
    padName = () => Platform.OS === "web" ? "'" : "",
    glyphCode = glyphMap[props.name],
    // For some reason, certain icons in Font Awesome are not displayed unless the container has a certain width. Those icons need their unicode code in the glyph map to work properly.
    icon = glyphCode ? glyphCode : props.name;

  // Set the friendly aliases for the font weights
  if (weight === "light") {
    weight = 300;
  } else if (weight === "regular") {
    weight = 400;
  } else if (weight === "solid") {
    weight = 900;
  }

  return (
    <Container flexDirection="row" alignItems="center" margins={margins} backgroundColor={backgroundColor}>
      {/* We have a simple Text component, Font Awesome handles changing the text "wifi" to an actual icon */}
      <Text
        selectable={false}
        style={[
          {
            // Since Android uses the name of the font file, we append the font weight to the end of the family
            fontFamily:
              padName() +
              "Font Awesome 5 Pro" +
              (Platform.OS === "android" ? " " + weight : "") +
              padName(),
            fontSize: props.iconSize,
            fontWeight: Platform.OS !== "android" ? weight + "" : null,
            color: props.color
          },
          props.style
        ]}
      >
        {icon}
      </Text>
    </Container>
  );
};

export default Icon;
